export const usmle2PedsModule = {
  id: "peds",
  title: "Pediatrics",
  sections: [
    {
      type: "text",
      content:
        "Vaccines: live vaccines are contraindicated in pregnancy and severe immunodeficiency.",
    },
    {
      type: "question",
      text: "Which is a live vaccine?",
      options: ["MMR", "Tdap", "Hepatitis B", "IPV"],
      correct: 0,
      explanation: "MMR is a live attenuated vaccine.",
    },
  ],
};
